import request from '@/utils/request.js';
// 获取新游推荐列表
export const getNewGameRecommendList = params =>
  request({
    url: '/v1/new_game_recommend/list',
    method: 'get',
    params,
  });
// 获取底部导航栏
export const getBottomNav = () =>
  request({
    url: '/v1/navigation/bottom',
    method: 'get',
  });
// 获取广告位banner轮播图
export const getBannerList = () =>
  request({
    url: '/v1/ad/banner',
    method: 'get',
  });
// 获取菜单列表
export const getMenuList = () => request({ url: '/v1/menu/list', method: 'get' });
// 发布贴子
export const addTopic = data => request({ url: '/v1/conversation/release', method: 'post', data });
// 绑定用户手机号码
export const bindUserPhone = data =>
  request({
    url: '/v1/forum_user/update_phone',
    method: 'post',
    data,
  });
// 获取手机验证码
export const getVerifyCode = data =>
  request({
    url: '/v1/sms/send',
    method: 'post',
    data,
  });
// 绑定用户游戏账号
export const bindUserGameAccount = data =>
  request({
    url: '/v1/game_account/bind',
    method: 'post',
    data,
    showToast: true
  });


// 获取盒子用户绑定账号信息
export const getBoxUserBindInfo = () =>
  request({
    url: '/v1/game_account/get_box_bind_info',
    method: 'get'
  });

// 用盒子绑定的账号绑定黑喵用户
export const bindBoxUserToBlackCatUser = data =>
  request({
    url: '/v1/game_account/bind_box_account',
    method: 'post',
    data,
    showToast: true
  });

// 保存微信一次性订阅结果
export const saveWechatOneTimeSubscribeResult = (overall_id, data) =>
  request({
    url: `/v1/permanent_sign_in/save_wechat_once_subscribe_record/${overall_id}`,
    method: 'post',
    data,
  });